import React from 'react';
import { flexRender } from '@tanstack/react-table';
import TableCheckbox from '../checkbox/TableCheckbox';

/**
 * @param table made using reactTable 
 * @returns 
 */
const TanstackTable = ({ table, from = '', renderSubComponent }) => {
  return (
    <table className='msync-tanstack msync-table'>
      <thead className='msync-table-header msync-report-header'>
        {table.getHeaderGroups().map((headerGroup, key) => {
          if (key === 0) return;
          return (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map(header => {
                const canSort = header.column.getCanSort();
                return (
                  <th
                    key={header.id}
                    data-key={header.id}
                    data-sortable={canSort}
                    className={`msync-table__cell msync-table__cell--heading ${header.column.columnDef.meta?.className ?? ''}`}
                  >
                    {header.isPlaceholder ? null : (
                        canSort ? (
                            <button
                                data-tgbl-table-sort={header.column.getIsSorted() || 'none'}
                                aria-label={header.column.id}
                                onClick={header.column.getToggleSortingHandler()}
                                className="msync-table__cell__sort"
                            >
                            {flexRender(header.column.columnDef.header, header.getContext())}
                            {{
                                asc: <span className="msync-visually-hidden">(ascending)</span>,
                                desc: <span className="msync-visually-hidden">(descending)</span>,
                            }[header.column.getIsSorted() as string] ?? null}
                            </button>
                        ) : (
                            flexRender(header.column.columnDef.header, header.getContext())
                        )
                    )}
                  </th>
                );
              })}
            </tr>
          );
        })}
      </thead>
      <tbody>
        {table.getRowModel().rows.map(row => {
          return (
            <>
              <tr key={row.id}>
                {row.getVisibleCells().map((cell, key) => {
                  return (
                      <td 
                          className='msync-table__cell'
                          key={cell.id}
                      >
                      {flexRender(cell.column.columnDef.cell, cell.getContext())}
                    </td>
                  );
                })}
              </tr>
              {row.getIsExpanded() && (
                <tr>
                  <td colSpan={row.getVisibleCells().length}>
                    { renderSubComponent(row) }
                  </td>
                </tr>
              )}
            </>
          );
        })}
      </tbody>
    </table>
  );
};

export default TanstackTable;
